import {
    ADDORUPDATELOADLIMIT_SUCCESS,
    ADDORUPDATELOADLIMIT_FAILED,
    RESET_ADDORUPDATELOADLIMIT,
    LOADING_ADDORUPDATELOADLIMIT,
    NETWORK_ERROR_ADDORUPDATELOADLIMIT,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetAddOrUpdateLoadLimit = () => {
    return { type: RESET_ADDORUPDATELOADLIMIT };
};

const addOrUpdateLoadLimit = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_ADDORUPDATELOADLIMIT });
    await partnerServices
        .post("addOrUpdateLoadLimit", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(addOrUpdateLoadLimitsuccess(res.data));
                    break;
                default:
                    dispatch(addOrUpdateLoadLimitFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({ type: NETWORK_ERROR_ADDORUPDATELOADLIMIT, payload: err });
        });
};
function addOrUpdateLoadLimitsuccess(data) {
    return {
        type: ADDORUPDATELOADLIMIT_SUCCESS,
        payload: data,
    };
}
function addOrUpdateLoadLimitFailed(data) {
    return {
        type: ADDORUPDATELOADLIMIT_FAILED,
        payload: data,
    };
}

export { resetAddOrUpdateLoadLimit, addOrUpdateLoadLimit };
